import { IntegrationFeature } from "../../index";

class IntegrationFeatureWebhook extends IntegrationFeature {
	constructor() {
		super();
	}

	static fromJson(json: any): IntegrationFeatureWebhook {
		return new IntegrationFeatureWebhook();
	}

	static get type(): string {
		return "webhook";
	}

	get id(): string {
		return IntegrationFeatureWebhook.type;
	}

	toJson() {
		return {
			type: IntegrationFeatureWebhook.type,
		};
	}
}

export { IntegrationFeatureWebhook };